import { PayloadAction } from "@reduxjs/toolkit";
import { GetClientsListForVendorPayload } from "../../../clients/payload/GetClientsListForVendor/GetClientsListForVendorPayload";
import { DashboardState } from "../../models/DashboardState";

const getClientsListForVendorFetch = (state: DashboardState, actions: PayloadAction<GetClientsListForVendorPayload>) => {
    state.isLoading = true;
}

export default getClientsListForVendorFetch;